export const REGEXP_EMAIL =
  /^[A-Z0-9_!#$%&'*+/=?`{|}~^.-]+@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,}(?:\.[a-z]{2})?)$/i;
export const REGEXP_NO_SPECIAL_CHARACTERS = /^[^`~!@#$%^&*+={}|\\:;“’<,>?]*$/;
export const REGEXP_PHONE_NUMBER = /^\+?[\d\s]{9,13}$/;
export const REGEXP_URL =
  /^(?<protocol>https?:\/\/|mailto:|tel:)(?<host>[+0-9]+|(?:[A-Za-z0-9-._+]+@)?[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+)(?<path>\/[[@+~%:/.\w_,\]#-]*)?((?<anchor>#[.!\w-=]+)|(?<query>\?['\-+=&;%@.,/\w_\-[\]]+)){0,2}$/i;
export const REGEXP_YOUTUBE_CHANNEL =
  /(?:https|http):\/\/(?:[\w]+\.)?youtube.com\/((c\/|channel\/|user\/)?[\w.-]+|@[\w.-]+)$/;
export const REGEXP_YOUTUBE_URL =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
export const REGEXP_DOMAIN =
  /^(?!www\.)(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z0-9-]{1,63})*(\.[A-Za-z]{2,})$/;
export const REGEXP_VALID_INSTAGRAM_USERNAME =
  /^[A-Za-z0-9_](?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}[A-Za-z0-9_]$/;
export const REGEXP_VALID_INSTAGRAM_HASHTAG = /^[^ !@#$%^&*(),.?":{}|<>]*$/;
